import React, {Component} from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import {setAllChecked, setSearchInputValue} from '../../../actions/permissions';
import CheckBox from "../CheckBox";
import {PERMISSION_BUTTONS} from "../../../reducers/permissions";
// import {debounce} from "lodash";

class PermissionsPanel extends Component {

  static propTypes = {
    changeAllPermissions: PropTypes.func.isRequired,
    setPermissions: PropTypes.func.isRequired
  };

  constructor(props) {
    super(props);
    // this.debouncedSearch = debounce(this.performSearch, 250);
    this.state = {
      searchText: ""
    };
  }

  componentWillUnmount() {
    this.props.setAllChecked(null);
    this.props.setSearchInputValue("");
  }

  handleInputChange = (e) => {
    const searchText = e.target.value;
    this.setState({
      searchText
    // }, () => this.debouncedSearch(searchText));
    });
    this.props.setPermissions(searchText)
  };

  performSearch = term => {
    this.props.setSearchInputValue(this.state.searchText);
  };

  handleAllButtonClick = (buttonType) => {
    this.props.setAllChecked(buttonType);
    this.props.changeAllPermissions(buttonType);
  };

  render() {
    const allChecked = this.props.allChecked;
    return (
      <div className="permissions-panel">
        <div className="fabricators-popup-row">
          {Object.values(PERMISSION_BUTTONS).map((button, buttonIndex) => (
            <div className={"fabricators-popup-col permissions-panel__col--" + (buttonIndex + 1)} key={buttonIndex}>
              <CheckBox checked={allChecked === button} text="All"
                        onChecked={() => this.handleAllButtonClick(button)} type="small" />
            </div>
          ))}
          <div className="fabricators-popup-col permissions-panel__col--4">
            <input type="text"
                   value={this.state.searchText}
                   className="generic-popup-textbox"
                   placeholder="Search permissions..."
                   onChange={this.handleInputChange}
            />
          </div>
        </div>
      </div>
    )
  }
}

const mapStateToProps = state => ({
  allChecked: state.permissions.allChecked,
  searchText: state.permissions.searchText
});

const mapDispatchToProps = {
  setAllChecked,
  setSearchInputValue
};

export default connect(mapStateToProps, mapDispatchToProps)(PermissionsPanel);
